import { useTranslation } from 'react-i18next';
import { useCreateBankAccount } from '@/query/queries/cash/useCreateBankAccount';
import { useGetBankAccountById } from '@/query/queries/cash/useGetBankAccountById';
import { useUpdateBankAccount } from '@/query/queries/cash/useUpdateBankAccount';
import { LanguageSwitcher } from '@scramble/ui';
import { Preloader } from '@/components/Preloader';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { NavButton } from './navigation';
import { Form } from './form';
import Logo from '@scramble/design-system/logo/scramble_logo_black.svg';
import s from './index.module.scss';

export const BankAccountForm = ({ accountId, onBack }) => {
  const { t } = useTranslation();
  const { mutateAsync: createBankAccount } = useCreateBankAccount();
  const { mutateAsync: updateBankAccount } = useUpdateBankAccount(accountId);
  const { data } = useGetBankAccountById(accountId);
  const { openSingleModal } = useModal();

  const showUnderReviewModal = () => {
    openSingleModal(MODAL_IDS.bank_account_under_review);
    onBack();
  }

  const onSubmit = async (values, { setSubmitting, setFieldError }) => {
    const bankStatementId = values.files[0]?.id;

    if (!bankStatementId) {
      setFieldError('files', t('validation:val_bank_statement_required_field'));
      return;
    }

    const payload = {
      country: values.country.label,
      country_code: values.country.code,
      beneficiary_name: values.beneficiary_name,
      account_number: values.account_number,
      bank_statement: bankStatementId,
    };

    if (!values.in_sepa_zone) {
      payload.swift = values.swift;
      payload.beneficiary_address = values.beneficiary_address;
      payload.beneficiary_bank = values.beneficiary_bank;
      payload.beneficiary_bank_address = values.beneficiary_bank_address;
    }

    const res = accountId ? await updateBankAccount(payload) : await createBankAccount(payload);
    if (res?.id) {
      showUnderReviewModal();
      return;
    }
    setSubmitting(false);
  };

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div className={s.header_container}>
          <div className={s.logo}>
            <img src={Logo} width={112} height={20} alt="logo" />
          </div>
          <LanguageSwitcher />
          <NavButton onBack={onBack} className={s.header_button} />
        </div>
      </div>
      {!accountId || (accountId && data) ? (
        <Form data={data} onSubmit={onSubmit} />
      ) : (
        <Preloader />
      )}
    </div>
  );
};